import _ from "lodash";
import { getCurrentStoreData } from "../websites/thunks";
import isWebsiteSharedWithCurrentUser from "../../helpers/shareAccess/isWebsiteSharedWithCurrentUser";
import { checkIsProPlan } from "../../helpers/user/checkIsProPlan";
import { SetupVersions } from "../../components/dashboard/CustomDomainSettingsNew";

export const isUserFreeNew = () => {
  return (dispatch, getState) => {
    const { currentWebsite } = dispatch(getCurrentStoreData());
    const { user } = getState();
    const { sharedAccesses } = getState();
    if (user.isPro) {
      return false;
    }
    if (!_.get(user, "data.additional_info.has_new_publish_rule", false)) {
      return false;
    }
    if (
      isWebsiteSharedWithCurrentUser(
        sharedAccesses,
        currentWebsite.id,
        user.data.email
      ).isTrue
    ) {
      return false;
    }
    return true;
  }
}

export const checkIfAgentsAvailable = () => {
  return (dispatch, getState) => {
    const { user, plans } = getState();
    const { currentWebsite } = dispatch(getCurrentStoreData());
    if (!checkIsProPlan(user, plans)) {
      return {
        isAvailable: false,
        message: "Upgrade to a paid plan to use agents",
      }
    }
    if (
      !_.get(currentWebsite, "is_custom_domain_active") ||
      !_.get(currentWebsite, "custom_domain")
    ) {
      return {
        isAvailable: false,
        message: "Connect custom domain to use agents",
      }
    }
    if (!_.get(user, "data.is_email_verified")) {
      return {
        isAvailable: false,
        message: "Verify your email to use agents",
      }
    }
    if (_.get(currentWebsite, "owner") !== _.get(user, "data.id")) {
      return {
        isAvailable: false,
        message: "Agents aren't available on shared websites",
      }
    }
    if (_.get(currentWebsite, "domain_setup_version") !== SetupVersions.APEX_TO_WWW) {
      return {
        isAvailable: false,
        message: "Agents aren't available on legacy domains",
      }
    }
    return {
      isAvailable: true,
      message: "",
    }
  }
}
